module.exports = __webpack_public_path__ + "static/media/monaco.9798d565.jpg";